import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import * as a from "../../../../constants/api";
import * as r from "../../../../constants/routes";
import FriendlyInfo from "../../../../components/FriendlyInfo";
import GamesTableSmart from "../../../../components/Lists/GraphicsAdmin/GamesTableSmart";
import TestTableSmart from "../../../../components/Lists/GraphicsAdmin/TestTableSmart";
import BarGraphics from "../../../../components/Lists/GraphicsAdmin/BarGraphics";
import RadarGraphic from "../../../../components/Lists/GraphicsAdmin/RadarGraphic";
// import PageHeader from "../../../../components/Headers/PageHeader";
import Crypto from "crypto-js";
import PageMain from "../../../../components/Main/PageMain";
import RoundButton from "../../../../components/Buttons/RoundButton";
import SessionContext from "../../../../context/sessionContext";
import Spinner from "../../../../components/Spinner";
import useFetch from "../../../../hooks/useFetch";
import pClasses from "../Users.module.scss";
import ClientsPdf from "../../../../components/Lists/GeneratePdf/index";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { getLastProperty } from "../../../../helpers";
import JourneyInfoCard from "../../../../components/Profile/JourneyInfoCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faLockOpen,
  faLock,
  faFilePdf,
  faEnvelope,
  faArrowLeft,
  faCopy,
  faCheckCircle,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ModalAlert from "./ModalAlert";
interface Info {
  journey: number;
  date_IA_start: string;
  date_IA_finish: string;
  status: number;
}

export default function UserList() {
  const history = useNavigate();
  const { t } = useTranslation();
  const cSession = useContext(SessionContext);
  const [open, setOpen] = useState(true);
  const [_content, setContent] = useState<any>(<></>);
  const [showGraph, setShowGraph] = useState(false);
  const [openModalAlert, setOpenModalAlert] = useState(false);
  const [openModalAlertTitle, setOpenModalAlertTitle] = useState("Alerta");
  const [dataIaFinish, setDataIaFinish] = useState(new Date());
  const [HasReavaliation, setHasReavaliation] = useState(false);
  const [openModalAlertMessage, setOpenModalAlertMessage] =
    useState("Esse é o alerta!");
  const [openModalAlertIcon, setOpenModalAlertIcon] = useState(<></>);
  const [openModalAlertButtons, setOpenModalAlertButtons] = useState(<></>);
  const [selectedJourney, setSelectedJourney] = useState<any>("1");
  const userInfos = useRef<any[]>([]);
  const [gamesInfo, , , listUserFetch]: any = useFetch({
    autoInit: false,
  });
  const [fetchedJourney, journeyIsLoading, , journeyFetch]: any = useFetch({
    autoInit: false,
  });
  const [listUser, , , listUserFetch2]: any = useFetch({
    autoInit: false,
  });
  const relat = new URL(window.location.href);
  let userSubFromUrl = [] as Array<any>;
  userSubFromUrl = relat.pathname.split("/").reverse();
  const NameUser = decodeURIComponent(userSubFromUrl[1]);
  let _user = listUser?.find(
    (user: any) => user.user_id === Number(userSubFromUrl[0])
  );

  useEffect(() => {
    _user = listUser?.find(
      (user: any) => user.user_id === Number(userSubFromUrl[0])
    );
  }, [listUser, NameUser]);
  const birthdate = _user?.birthdate ? new Date(_user?.birthdate) : null;

  const [toggleState, setToggleState] = useState(1);
  const lastIndex = fetchedJourney && getLastProperty(fetchedJourney);

  const DataTests = fetchedJourney;
  //atualizar para pegar a jornada escolhida
  useEffect(() => {
    setHasReavaliation(
      fetchedJourney && fetchedJourney[selectedJourney]?.journey_code === 3
    );
  }, [DataTests]);
  useEffect(() => {
    setDataIaFinish(
      new Date(DataTests && DataTests[selectedJourney]?.date_IA_finish)
    );
  }, [fetchedJourney]);
  const dataIaFinishFormated = dataIaFinish.toLocaleDateString("pt-BR");

  const toggleTab = (index: any) => {
    setToggleState(index);
  };

  const [namelist, setNamelist] = useState<any>();
  const [Graph, setGraph] = useState<any>();
  const [listid, setListid] = useState<any>();
  const [listname, setListname] = useState<any>();
  const [hasUser, setHasUser] = useState<any>();
  const [sub, setSub] = useState<any>({});
  const [userGroupName, setUserGroupName] = useState<any>(_user?.group_name);

  function listselect(event: React.FormEvent<HTMLSelectElement>) {
    setListid(event.currentTarget.value);
    const getTestsUrlOnSelect = a.GET_API_TESTS(event.currentTarget.value);
    if (sub) {
      userInfos.current = [];
      journeyFetch({ url: getTestsUrlOnSelect });
    }
    setListname(
      event.currentTarget.options[event.currentTarget.selectedIndex].innerHTML
    );
    userInfos.current = [];
    setShowGraph(false);
  }

  useEffect(() => {
    userInfos.current = [];
    if (
      fetchedJourney &&
      userInfos.current.length !== Object.values(fetchedJourney).length
    )
      Object.values(fetchedJourney)?.map((info: any, index: any) => {
        userInfos.current.push({
          access_code: _user?.access_code,
          active: _user?.active,
          activity_type: _user?.activity_type,
          birthdate: _user?.birthdate,
          date_created: _user?.date_created,
          date_last_play: _user?.date_last_play,
          group_name: _user?.group_name,
          group_uid: _user?.group_uid,
          is_email: _user?.is_email,
          journey: index + 1,
          permission: _user?.permission,
          professional_email: _user?.professional_email,
          professional_sub: _user?.professional_sub,
          shots: _user?.shots,
          date_IA_start: info.date_IA_start?.split(" ")[0],
          date_IA_finish: info.date_IA_finish?.split(" ")[0],
          status: info.journey_code,
          user_id: info.user_uid,
          company_uid: info.company_uid,
          registry: NameUser,
          journey_code: info?.journey_code,
          amt_plays: info?.amt_plays,
        });
      });
  }, [fetchedJourney]);
  function copyFunc(param: any, event: any, encrypt: boolean) {
    if (encrypt) {
      const encryptMessage =
        a.AUDIOFOCO_LINK +
        "/login?link=" +
        encodeURIComponent(
          Crypto.AES.encrypt(JSON.stringify(param), a.SECRET_KEY).toString()
        );
      navigator.clipboard.writeText(encryptMessage);
    } else {
      navigator.clipboard.writeText(param);
    }
    const spanElement = event.target.querySelector("span");
    spanElement?.classList?.add(pClasses.copyAnim);
    setTimeout(() => {
      spanElement?.classList?.remove(pClasses.copyAnim);
    }, 1000);
  }

  useEffect(() => {
    setSub(cSession.admin);
  }, [cSession]);
  useEffect(() => {
    setHasUser(fetchedJourney !== null);
  }, [fetchedJourney]);

  useEffect(() => {
    if (listid) {
      const urlAPIReports = a.GET_API_REPORT(listid);
      if (sub) listUserFetch({ url: urlAPIReports });
      const relat = new URL(window.location.href);
      let urlconcat = [] as Array<any>;
      urlconcat = relat.pathname.split("smart");
      window.history.replaceState(
        {},
        "",
        urlconcat[0] + "smart/" + listname + "/" + listid
      );
    }
  }, [listid, listname]);

  useEffect(() => {
    listUserFetch2({ url: a.API_USERS_ALL_SMART });
  }, [listUserFetch2]);

  useEffect(() => {
    if (listUser) {
      const tmpArray: any = [];

      listUser.map((user: any) => {
        tmpArray.push(
          <option key={user.user_id} value={user.user_id}>
            {user.registry}
          </option>
        );
      });

      setNamelist(tmpArray);
    }
  }, [listUser]);

  useEffect(() => {
    const relat = new URL(window.location.href);
    let userSubFromUrl = [] as Array<any>;
    userSubFromUrl = relat.pathname.split("/").reverse();

    const getTestsUrl = a.GET_API_TESTS(userSubFromUrl[0]);
    if (sub) {
      userInfos.current = [];
      journeyFetch({ url: getTestsUrl });
    }
  }, [journeyFetch, sub, listid]);

  useEffect(() => {
    const relat = new URL(window.location.href);
    let userSubFromUrl = [] as Array<any>;
    userSubFromUrl = relat.pathname.split("/").reverse();
    const urlAPIReports = a.GET_API_REPORT(userSubFromUrl[0]);
    if (sub) listUserFetch({ url: urlAPIReports });
  }, [listUserFetch, sub, listid]);
  useEffect(() => {
    const _selectedJourney =
      !Number.isNaN(Number(selectedJourney)) &&
        Number(selectedJourney) !== undefined &&
        selectedJourney
        ? Number(selectedJourney)
        : 1;
    const GraphSelect = () => {
      switch (toggleState) {
        case 1: {
          return (
            <>
              <TestTableSmart
                fetchedJourney={
                  fetchedJourney ? fetchedJourney[_selectedJourney] : []
                }
                showUser
                showActiveStatus
                showAccess_code
                showBirthdate
                _selectedJourney={_selectedJourney}
              />
            </>
          );
        }
        case 2: {
          return (
            <>
              <RadarGraphic
                fetchedJourney={
                  fetchedJourney ? fetchedJourney[_selectedJourney] : []
                }
              // showUser
              // showActiveStatus
              // showAccess_code
              // showBirthdate
              />
            </>
          );
        }
        case 3: {
          return (
            <>
              <GamesTableSmart
                users={gamesInfo && gamesInfo}
                gamesInfo={gamesInfo}
                choosedShot={String(_selectedJourney)}
                showUser
                showActiveStatus
                showAccess_code
                showBirthdate
              />
            </>
          );
        }

        case 4: {
          return (
            <>
              <BarGraphics
                fetchedJourney={
                  fetchedJourney ? fetchedJourney[_selectedJourney] : []
                }
              // showUser
              // showActiveStatus
              // showAccess_code
              // showBirthdate
              />
            </>
          );
        }
        default: {
          return <Spinner center />;
        }
      }
    };
    setGraph(GraphSelect);
  }, [fetchedJourney, toggleState, gamesInfo, selectedJourney]);

  useEffect(() => {
    if (journeyIsLoading) {
      setContent(<Spinner center />);
      return;
    }
    if (fetchedJourney) {
      if (fetchedJourney[lastIndex].journey_code >= 0) {
        setContent(Graph);
      }
      if (fetchedJourney[lastIndex].journey_code === -2) {
        setContent(
          <FriendlyInfo text={t("infos.user_without_birthdate")}>
            <RoundButton
              small
              center
              text={t("global.back")}
              title={t("global.back")}
              onClick={() => history(r.R_A_USERS_LIST_SMART)}
            />
          </FriendlyInfo>
        );
      } else if (fetchedJourney[lastIndex].journey_code === -1) {
        setContent(
          <FriendlyInfo text={t("infos.user_without_tests")}>
            <RoundButton
              small
              center
              text={t("global.back")}
              title={t("global.back")}
              onClick={() => history(r.R_A_USERS_LIST_SMART)}
            />
          </FriendlyInfo>
        );
      }
    }
  }, [journeyIsLoading, Graph, listid]);

  const headerGraphs = (
    <div className={pClasses.contentUserEndJourney}>
      <div className={pClasses.contentUserEndJourneyMenu}>
        <div className={pClasses.Tab}>
          <button
            className={`${toggleState === 1 ? pClasses.activetabs : pClasses.tabs
              }`}
            style={{
              borderBottom: toggleState === 1 ? "4px solid" : "",
            }}
            onClick={() => toggleTab(1)}
          >
            {t("userProfile.test_results")}
          </button>
          <button
            className={`${toggleState === 4 ? pClasses.activetabs : pClasses.tabs
              }`}
            style={{
              borderBottom: toggleState === 4 ? "4px solid" : "",
            }}
            onClick={() => toggleTab(4)}
          >
            {t("userProfile.bar_chart")}
          </button>
          {/* <button
            className={`${toggleState === 2 ? pClasses.activetabs : pClasses.tabs
              }`}
            style={{
              borderBottom: toggleState === 2 ? "4px solid" : "",
            }}
            onClick={() => toggleTab(2)}
          >
            {t("userProfile.radar_chart")}
          </button> */}
          <button
            className={`${toggleState === 3 ? pClasses.activetabs : pClasses.tabs
              }`}
            style={{
              borderBottom: toggleState === 3 ? "4px solid" : "",
            }}
            onClick={() => toggleTab(3)}
          >
            {t("userProfile.games")}
          </button>
        </div>
      </div>
      {/* alterar aqui. bug do relatório que não imprime. */}
      {HasReavaliation ? (
        <RoundButton
          small
          className={pClasses.BtnPdf}
          text={t("global.print_final_report")}
          faIcon={faFilePdf}
          title={t("global.print_final_report")}
          onClick={() => {
            ClientsPdf({
              DataTests: fetchedJourney,
              NameUser,
              selectedJourney,
              t,
            });
          }}
        />
      ) : fetchedJourney && fetchedJourney[lastIndex].journey_code >= 1 ? (
        <RoundButton
          small
          className={pClasses.BtnPdf}
          text={t("global.print_final_report")}
          faIcon={faFilePdf}
          title={t("global.print_final_report")}
          onClick={() => setOpen(false)}
        />
      ) : null}

      <Dialog
        open={!open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
        // className={pClasses.TextDialogPrimary}
        >
          {t("global.print_report")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Você poderá imprimir o relatório, assim que o usuário concluir a reavaliação. O usuário poderá fazer a reavaliação a partir do dia ${dataIaFinishFormated}.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {
            <>
              <Button
                onClick={() => setOpen(true)}
                // className={pClasses.TextDialogButtons}
                autoFocus
              >
                {t("global.ok")}
              </Button>
            </>
          }
        </DialogActions>
      </Dialog>
    </div>
  );

  useEffect(() => {
    if (fetchedJourney)
      Object.keys(fetchedJourney).map((key: string) => {
        const journey = Number(key);
        if (userInfos.current.length < Object.keys(fetchedJourney).length)
          userInfos.current.push({
            date_IA_start:
              fetchedJourney[journey]?.date_IA_start?.split(" ")[0],
            date_IA_finish:
              fetchedJourney[journey]?.date_IA_finish?.split(" ")[0],
            status: fetchedJourney[journey]?.journey_code,
            user_id: fetchedJourney[journey]?.user_uid,
            company_uid: fetchedJourney[journey]?.company_uid,
            journey: journey,
            registry: NameUser,
            professional_sub: _user?.professional_sub,
            professional_email: _user?.professional_email,
            access_code: _user?.access_code,
            birthdate: _user?.birthdate,
            date_created: _user?.date_created,
            date_updated: _user?.date_updated,
            activity_type: _user?.activity_type,
            active: _user?.active,
            context: _user?.context,
            permission: _user?.permission,
            journey_code: _user?.journey_code,
            is_email: _user?.is_email,
            amt_plays: _user?.amt_plays,
            date_last_play: _user?.date_last_play,
            group_name: _user?.group_name,
            group_uid: _user?.group_uid,
            shots: _user?.shots,
          });
      });
  }, [fetchedJourney, _user]);

  const [, isLoadingAddJourney, , fetchShots]: any = useFetch({
    autoInit: false,
  });
  const [, isLoadingSendingEmail, , fetchSendEmail]: any = useFetch({
    autoInit: false,
  });
  const [, isLoadingToggle, , fetchToggle]: any = useFetch({
    autoInit: false,
  });
  const addJourneyConfirm = (userInfos: any) => {
    let userId: string[] | string = window.location.href;
    userId = String(userId).split("/");
    userId = userId[userId.length - 1];
    const user_uid = userInfos.current[0].user_id
      ? userInfos.current[0].user_id
      : userId;
    const company_uid = userInfos.current[0].company_uid;
    const shots = userInfos.current[0].shots;
    if (shots >= 1) {
      setOpenModalAlertMessage(
        "O usuário já possui uma Jornada Audiofoco ativa. Por favor, finalize a jornada atual para adicionar uma nova."
      );
      setOpenModalAlertTitle("Jornada ativa");
      setOpenModalAlertIcon(
        <FontAwesomeIcon
          size={"2x"}
          style={{ color: "orange" }}
          icon={faExclamationTriangle}
        />
      );
      setOpenModalAlertButtons(
        <div
          className={pClasses.profileButton + " " + pClasses.addJourneyButtons}
        >
          <Button
            className={pClasses.buttonCancelJourneyError}
            onClick={() => setOpenModalAlert(false)}
          >
            Voltar ao perfil
          </Button>
        </div>
      );
      return setOpenModalAlert(true);
    }
    setOpenModalAlertButtons(
      <div
        className={pClasses.profileButton + " " + pClasses.addJourneyButtons}
      >
        <Spinner center />
        <Button
          className={pClasses.buttonCancelJourney}
          onClick={() => setOpenModalAlert(false)}
        >
          {t("global.cancel")}
        </Button>
      </div>
    );
    fetchShots({
      method: "POST",
      url: a.UPDATE_USER_SHOTS,
      data: {
        user_uid: user_uid,
        user_id: user_uid,
        company_uid: company_uid,
      },
      onSuccess: () => {
        userInfos.current[0].shots = 1;
        setOpenModalAlertTitle("Jornada adicionada!");
        setOpenModalAlertMessage(
          "A nova jornada foi adicionada ao perfil do usuário com sucesso!"
        );
        setOpenModalAlertIcon(
          <FontAwesomeIcon size={"2x"} icon={faCheckCircle} />
        );
        setOpenModalAlertButtons(
          <div
            className={
              pClasses.profileButton + " " + pClasses.addJourneyButtons
            }
          >
            <Button
              className={pClasses.buttonCancelJourneyError}
              onClick={() => setOpenModalAlert(false)}
            >
              Voltar ao perfil
            </Button>
          </div>
        );
        setOpenModalAlert(true);
      },
      onError: () => {
        setOpenModalAlertTitle("Erro");
        setOpenModalAlertMessage(
          t(
            "global.Error_adding_journey_Check_if_the_user_is_able_to_receive_a_new_journey_and_if_there_are_still_journeys_to_add"
          )
        );
        setOpenModalAlertIcon(
          <FontAwesomeIcon
            size={"2x"}
            style={{ color: "orange" }}
            icon={faExclamationTriangle}
          />
        );
        setOpenModalAlertButtons(
          <div
            className={
              pClasses.profileButton + " " + pClasses.addJourneyButtons
            }
          >
            <Button
              className={pClasses.buttonCancelJourneyError}
              onClick={() => setOpenModalAlert(false)}
            >
              Voltar ao perfil
            </Button>
          </div>
        );
        setOpenModalAlert(true);
      },
    });
  };
  const addJourney = (userInfos: any) => {
    setOpenModalAlertTitle("Adicionar nova jornada");
    setOpenModalAlertMessage(
      "Por favor, confirme se deseja prosseguir com a adição de uma nova triagem para o usuário. Esta ação não poderá ser desfeita."
    );
    setOpenModalAlertIcon(<></>);
    setOpenModalAlertButtons(
      <div
        className={pClasses.profileButton + " " + pClasses.addJourneyButtons}
      >
        <Button
          className={pClasses.buttonConfirmJourney}
          disabled={isLoadingAddJourney}
          onClick={() => addJourneyConfirm(userInfos)}
        >
          {t("global.confirm_new_journey")}
        </Button>
        <Button
          className={pClasses.buttonCancelJourney}
          onClick={() => setOpenModalAlert(false)}
        >
          {t("global.cancel")}
        </Button>
      </div>
    );
    setOpenModalAlert(true);
  };

  const sendEmail = (userInfos: any) => {
    fetchSendEmail({
      method: "POST",
      url: a.API_USER_RESEND_PASSWORD,
      data: {
        company_uid: userInfos.company_uid,
        registry: userInfos.registry,
        access_code: _user?.access_code,
      },
      onSuccess: () => {
        alert("email send!");
      },
      onError: () => {
        alert("Erro ao enviar e-mail! Tente novamente mais tarde.");
      },
    });
  };

  const btnAddJourney = (
    _user?.shots == 0 && _user?.journey_code == 3 ? <span className={pClasses.profileButton}>
      <Button
        disabled={isLoadingAddJourney}
        title={t("userProfile.add_journey")}
        onClick={() => {
          if (userInfos.current.length > 0) addJourney(userInfos);
        }}
        size="small"
      >
        <span>
          <FontAwesomeIcon icon={faPlus} />
          {!isLoadingAddJourney
            ? t("userProfile.add_journey")
            : t("userProfile.loading")}
        </span>
      </Button>
    </span> : <></>
  );
  const btnSendEmail = (
    <span className={pClasses.profileButton}>
      {_user?.is_email && (
        <Button
          disabled={isLoadingSendingEmail}
          title={t("global.send_email")}
          onClick={() => {
            if (userInfos.current.length > 0) sendEmail(userInfos.current[0]);
          }}
          size="small"
        >
          <span>
            <FontAwesomeIcon icon={faEnvelope} />
            {!isLoadingSendingEmail
              ? t("global.send_email")
              : t("userProfile.loading")}
          </span>
        </Button>
      )}
    </span>
  );
  const createTempModel = (
    fnGetPermission: string | null,
    fnGetUsersJsonFromList: Array<any> | null
  ) => {
    const model = {
      permission: fnGetPermission,
      users: fnGetUsersJsonFromList,
    };
    return model;
  };
  const btnBlockUser = (
    <span className={pClasses.profileButton}>
      <Button
        disabled={isLoadingToggle}
        title={t("userProfile.block")}
        onClick={() => {
          if (userInfos.current.length > 0 && _user.active)
            fetchToggle({
              method: "POST",
              url: a.API_USERS_REMOVE,
              data: [{ ..._user }],
              onSuccess: () => {
                alert("Usuário bloqueado");
                _user.active = 0;
              },
              onError: () => {
                alert("Erro ao bloquear Usuário");
              },
            });
          else {
            fetchToggle({
              method: "PUT",
              url: a.API_USERS_ACTIVE,
              data: createTempModel("10", [{ ..._user }]),
              onSuccess: () => {
                _user.active = 1;
              },
            });
          }
        }}
        size="small"
      >
        <span>
          <FontAwesomeIcon icon={faLock} />
          {isLoadingToggle
            ? t("userProfile.loading")
            : _user?.active
              ? t("userProfile.block")
              : t("userProfile.unblock")}
        </span>
      </Button>
    </span>
  );

  let dd: string | number | null = birthdate?.getDate()
    ? birthdate?.getDate()
    : null;
  dd = Number(dd) < 10 ? "0" + dd : dd;
  let mm: string | number | undefined | null = String(birthdate?.getMonth())
    ? birthdate?.getMonth()
    : null;
  mm = String(Number(mm) + 1);
  if (Number(mm) < 10) mm = "0" + mm;

  const insertGroup = (e: any) => {
    e.preventDefault();
    // const groupInfo = groupsUsers?.find(
    //   (group: any) => String(group.id) === String(newUserGroup.current)
    // );
    // isLoadingGroup.current = true;
    // if (groupInfo?.name && groupInfo?.id)
    //   fetchUserGroup({
    //     method: "POST",
    //     url: UPDATE_USER_GROUP,
    //     data: {
    //       group_name: groupInfo?.name,
    //       group_uid: groupInfo?.id,
    //       user_uid: userInfos?.uid,
    //     },
    //     onSuccess: () => {
    //       alert("Grupo adicionado");
    //       changedGroup();
    //       isLoadingGroup.current = false;
    //       setUserGroupName(groupInfo?.name);
    //     },
    //     onError: () => {
    //       alert("Falure");
    //       isLoadingGroup.current = false;
    //     },
    //   });
    // else {
    //   isLoadingGroup.current = false;
    //   alert("Escolha um grupo");
    // }
  };
  const handlerUserGroup = (newGroup: any) => {
    // newUserGroup.current = newGroup;
  };
  const [newGroupsUsers, , , groupsUsersFetch]: any = useFetch({
    autoInit: false,
  });
  const groupsUsers: any = [];
  const _selectGroups = (
    <form
      style={{
        display: "flex",
        width: "75%",
        justifyContent: "flex-start",
        alignItems: "center",
        alignContent: "center",
        gap: "10px",
      }}
      onSubmit={insertGroup}
    >
      <div>
        {!_user?.group_name
          ? t("global.insert_group")
          : t("global.change_group")}
        :
      </div>
      <Select
        onChange={(e) => handlerUserGroup(e.target.value)}
        name="group"
        id="group"
        label={t("global.choose")}
        style={{ width: "25%", marginBottom: "10px" }}
      >
        {newGroupsUsers
          ? newGroupsUsers?.map((group: any) => {
            if (group.status === "active" && userGroupName !== group.name)
              return (
                <MenuItem key={group.id} value={group.id}>
                  {group.name}
                </MenuItem>
              );
          })
          : groupsUsers?.map((group: any) => {
            if (group.status === "active" && userGroupName !== group.name)
              return (
                <MenuItem key={group.id} value={group.id}>
                  {group.name}
                </MenuItem>
              );
          })}
      </Select>
      <Button
        // disabled={isLoadingGroup.current}
        type="submit"
        variant="contained"
        color="primary"
        style={{ height: "25%", margin: "10px 0 10px 10px" }}
      >
        {userGroupName ? t("global.change") : t("global.insert")}
      </Button>
    </form>
  );
  const headerTitle = `${t("userProfile.profile_from")} ${userInfos?.current[0]?.registry
    }`;
  const _header = (
    <>
      {userInfos.current.length ? (
        <div className={pClasses.headerProfile}>
          <div className={pClasses.firstRow}>
            <Button
              onClick={() =>
                !showGraph
                  ? history("/admin/usuarios/lista/smart")
                  : setShowGraph(false)
              }
            >
              <div className={pClasses.goBackButtonReports}>
                <div>
                  <FontAwesomeIcon icon={faArrowLeft} />
                </div>
                <div>Voltar</div>
              </div>
            </Button>
            <select
              className={pClasses.SelectUserSmartHeader}
              onChange={listselect}
            >
              <option disabled selected>
                {t("global.choose_another_user")}...
              </option>
              {namelist}
            </select>
          </div>
          <div className={pClasses.secondRow}>
            <div className={pClasses.titleActive}>
              <p>
                {headerTitle}{" "}
                <span
                  className={
                    _user?.active
                      ? pClasses.status + " " + pClasses.ativo
                      : pClasses.status + " " + pClasses.inativo
                  }
                >
                  {_user?.active ? t("global.active") : t("global.inactive")}
                  <FontAwesomeIcon
                    title={
                      _user?.active
                        ? t("global.turn_user_off")
                        : t("global.turn_user_on")
                    }
                    icon={_user?.active ? faLockOpen : faLock}
                  />
                </span>
              </p>
            </div>
            {!showGraph && (
              <div className={pClasses.buttonTitleActive}>
                {btnAddJourney}
                {btnSendEmail}
                {btnBlockUser}
              </div>
            )}
          </div>
          <div className={pClasses.thirdRow}>
            <div>
              <div>
                {t("userProfile.birthdate")}:{" "}
                {birthdate
                  ? ` ${mm}/${birthdate?.getFullYear()}`
                  : `${t("userProfile.not_registered")}`}
              </div>
              {showGraph ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      gridGap: "15px",
                      flexDirection: "row",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {t("global.choose_journey")}:
                    </div>
                    <select
                      className={pClasses.selectJourneyClass}
                      onChange={(e) => {
                        setSelectedJourney(Number(e.target.value));
                        setHasReavaliation(
                          fetchedJourney &&
                          fetchedJourney[Number(e.target.value)]
                            ?.journey_code === 3
                        );
                      }}
                    >
                      {`${t("global.journey")}: ${selectedJourney}!`}
                      {Object.keys(fetchedJourney).map(
                        (journey: any, index: number) => (
                          <option
                            key={index}
                            selected={index === Number(selectedJourney) - 1}
                            value={index + 1}
                          >{`${t("global.journey")}: ${index + 1}`}</option>
                        )
                      )}
                    </select>
                  </div>
                </>
              ) : (
                <></>
              )}
              {/* <div>Grupo {_user?.group_name} </div> */}
            </div>

            <div>
              <div>
                <p>
                  {t("userProfile.acesscode")}:{" "}
                  <a
                    className={pClasses.primary + " " + pClasses.bold}
                    onClick={(event) =>
                      copyFunc(_user?.access_code, event, false)
                    }
                  >
                    {_user?.access_code}
                    <FontAwesomeIcon
                      className={pClasses.copyIcon}
                      icon={faCopy}
                    />
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
  const journeyCards: any = userInfos.current.map((info: Info) => {
    return (
      <JourneyInfoCard
        key={info.journey}
        userInfos={info}
        showGraph={showGraph}
        setShowGraph={setShowGraph}
        setSelectedJourney={setSelectedJourney}
      />
    );
  });

  return (
    <>
      <div className={pClasses.JourneysInfoArea}>
        <div>{_header}</div>
        {showGraph && headerGraphs}
        <div
          style={{
            border: !showGraph ? "1px solid #E0E0E0" : "",
            padding: !showGraph ? "5%" : "",
            borderRadius: !showGraph ? "4px" : "",
          }}
        >
          <div className={pClasses.subAreaCardsJourneyInfos}>
            {!showGraph && userInfos.current.length ? (
              <>
                <div className={pClasses.jouneyConuntArea}>
                  {userInfos.current.length
                    ? `${t("userProfile.realized_journeys")} (${String(
                      userInfos.current.length
                    )})`
                    : "0"}
                </div>
                {journeyCards}
              </>
            ) : (
              <>{!showGraph && <Spinner center />}</>
            )}{" "}
          </div>
        </div>
      </div>
      <PageMain>{showGraph && _content}</PageMain>
      <ModalAlert
        open={openModalAlert}
        openModalAlertTitle={openModalAlertTitle}
        openModalAlertMessage={openModalAlertMessage}
        openModalAlertIcon={openModalAlertIcon}
        openModalAlertButtons={openModalAlertButtons}
        onCloseModal={() => setOpenModalAlert(false)}
      />
    </>
  );
}
